export const PROJECT_TABS = Object.freeze({
  PROJECTS: "projects",
  PARTNER_STATISTICS: "partnerStatistics",
});
